/**
 * Роли в HR (03.10, владелец): RoleTags — короткие кириллические теги в строке 30px
 * (цвет роли, порядок — от старшей), RoleChips — пять переключателей ролей у ИО в
 * раскрытой строке. Правило «последнюю роль не снять» и «роль ИО не снять с себя и
 * с последнего ИО» держит сервер; здесь — только вид. Справочник ролей один на API и
 * кабинет: @ub/shared/staffRoles.
 */
import { STAFF_ROLES, STAFF_ROLE_LABELS, sortRoles, type StaffRoleId } from "@ub/shared/staffRoles";
import css from "./roster.module.css";

/** Короткие подписи для строки: «Оператор» в теге на 375px не помещается рядом с именем. */
export const ROLE_SHORT: Record<StaffRoleId, string> = { eo: "EO", oo: "ОО", dc: "ДК", operator: "Опер", admin_hall: "Адм" };

export const roleCls = (r: StaffRoleId): string => css[r] ?? "";

export function RoleTags({ roles }: { roles: readonly StaffRoleId[] }) {
  return (
    <span className={css.tags}>
      {sortRoles(roles).map((r) => (
        <span key={r} className={`${css.tag} ${roleCls(r)}`} title={STAFF_ROLE_LABELS[r]}>{ROLE_SHORT[r]}</span>
      ))}
    </span>
  );
}

export function RoleChips({ roles, disabled, onToggle }: {
  roles: readonly StaffRoleId[];
  disabled?: boolean;
  onToggle: (r: StaffRoleId) => void;
}) {
  return (
    <div className={css.chips} role="group" aria-label="Роли">
      {STAFF_ROLES.map((r) => {
        const on = roles.includes(r);
        return (
          <button key={r} type="button" aria-pressed={on} disabled={disabled}
            className={`${css.chip} ${on ? roleCls(r) : ""}`} onClick={() => onToggle(r)}>
            {STAFF_ROLE_LABELS[r]}
          </button>
        );
      })}
    </div>
  );
}
